import React, { Component } from "react";
import Popup from "reactjs-popup";

const contentStyle = {
  width: "90%",
  height: "90%",
  paddingLeft: "30px",
  overflow: "auto"
};

export default class Jobs extends Component {
  render() {
    return (
      <section id="jobs" className="section-jobs">
        <div className="row">
          <div className="col-sm-12">
            <h2>Careers</h2>
            <h3>Great Vision + Great People = Success.</h3>
          </div>
        </div>

        <div className="row jobOpeningSquares">
          <Popup
            trigger={
              <div className="span4 project-wrp">
                <div className="profile-photo">
                  <img
                    src={require("../../assets/img/IOSMinThumb.png")}
                    alt="IOS thumb"
                  />
                </div>
                <div className="project-client">Full-Time/Part-Time</div>
                <div className="project-name">iOS Developer</div>
              </div>
            }
            overlayStyle={{ background: "rgba(7,7,7,0.4" }}
            contentStyle={contentStyle}
            modal={true}
            closeOnDocumentClick
            lockScroll={true}
          >
            {this.renderDeveloper("iosdeveloper")}
          </Popup>

          <Popup
            trigger={
              <div className="span4 project-wrp">
                <div className="profile-photo">
                  <img
                    src={require("../../assets/img/AndroidMinThumb.png")}
                    alt="Android Thumb"
                  />
                </div>
                <div className="project-client">Full-Time/Part-Time</div>
                <div className="project-name">Android Developer</div>
              </div>
            }
            className="popupWindow"
            overlayStyle={{ background: "rgba(7,7,7,0.4" }}
            contentStyle={contentStyle}
            modal={true}
            closeOnDocumentClick
            lockScroll={true}
          >
            {this.renderDeveloper("androiddeveloper")}
          </Popup>
          <Popup
            trigger={
              <div className="span4 project-wrp">
                <div className="profile-photo">
                  <img
                    src={require("../../assets/img/MobileMinThumb.png")}
                    alt="Mobile"
                  />
                </div>
                <div className="project-client">Part-Time</div>
                <div className="project-name">Mobile Developement Intern</div>
              </div>
            }
            className="popupWindow"
            overlayStyle={{ background: "rgba(7,7,7,0.4" }}
            contentStyle={{
              width: "90%",
              height: "90%",
              paddingLeft: "30px",
              overflow: "auto"
            }}
            modal={true}
            closeOnDocumentClick
            lockScroll={true}
          >
            {this.renderDeveloper("mobiledevelopmentintern")}
          </Popup>
          <Popup
            trigger={
              <div className="span4 project-wrp">
                <div className="profile-photo">
                  <img
                    src={require("../../assets/img/FrontEndMinThumb.png")}
                    alt="FrontEnd"
                  />
                </div>
                <div className="project-client">Full-Time/Part-Time</div>
                <div className="project-name">Front-End Developer</div>
              </div>
            }
            className="popupWindow"
            overlayStyle={{ background: "rgba(7,7,7,0.4" }}
            contentStyle={contentStyle}
            modal={true}
            closeOnDocumentClick
            lockScroll={true}
          >
            {this.renderDeveloper("frontenddeveloper")}
          </Popup>
          <Popup
            trigger={
              <div className="span4 project-wrp">
                <div className="profile-photo">
                  <img
                    src={require("../../assets/img/BackEndMinThumb.png")}
                    alt="BackEnd"
                  />
                </div>
                <div className="project-client">Full-Time/Part-Time</div>
                <div className="project-name">Back-End Developer</div>
              </div>
            }
            className="popupWindow"
            overlayStyle={{ background: "rgba(7,7,7,0.4" }}
            contentStyle={contentStyle}
            modal={true}
            closeOnDocumentClick
            lockScroll={true}
          >
            {this.renderDeveloper("backenddeveloper")}
          </Popup>
          <Popup
            trigger={
              <div className="span4 project-wrp">
                <div className="profile-photo">
                  <img
                    src={require("../../assets/img/WebMinThumb.png")}
                    alt="Web"
                  />
                </div>
                <div className="project-client">Part-Time</div>
                <div className="project-name">Web Developement Intern</div>
              </div>
            }
            className="popupWindow"
            overlayStyle={{ background: "rgba(7,7,7,0.4" }}
            contentStyle={contentStyle}
            modal={true}
            closeOnDocumentClick
            lockScroll={true}
          >
            {this.renderDeveloper("webdevelopmentintern")}
          </Popup>
        </div>
      </section>
    );
  }
  renderDeveloper(job) {
    if (job === "iosdeveloper") {
      return (
        <div>
          <div id="iosdeveloper" className="modal-box">
            <h2>IOS Developer</h2>
            <div className="jobDescription">
              <b>Type:</b> Full-Time/Part-Time
              <br />
              <b>Location:</b> Irvine, CA
              <br />
              <b>Education: </b>Bachelor's Degree or Master's Degree in Computer
              Science
              <br />
            </div>
            <div className="jobDescription">
              <h5>Responsibility:</h5>
              <ul>
                <li>
                  Develop state of the art iOS applications with siginicant
                  client-server integration
                </li>
                <li>
                  Plenty of hands-on coding and optimization to meet esthetics
                  and business objective
                </li>
                <li>
                  Agile collaboration with designers, server development teams,
                  as well as Android and Windows Phone 8 counterparts
                </li>
              </ul>
            </div>
            <div className="jobDescription">
              <h5>Requirements:</h5>
              <ul>
                <li>
                  Bachelor's or Master's degree in computer science or
                  equivalent
                </li>
                <li>
                  Familiar with all phases of the software development life
                  cycle and desire to apply this formally in a startup
                  environment
                </li>
                <li>
                  Detail oriented, passionate about software development, and a
                  great team spirit
                </li>
                <li>
                  Excellent communication skills and desire to work in a cross
                  functional team
                </li>
                <li>
                  Passion to implement breath-taking and efficient user
                  interfaces in collaboration with dedicated UI design team
                </li>
                <li>
                  Hands-on software development experience with object oriented
                  programming languages and design patterns
                </li>
                <li>
                  Experience with Objective C and preferably one significant
                  application delivered to the Apple App Store
                </li>
                <li>
                  Experience with REST/JSON based client-server communication,
                  Push Notification Services, and Social Media Integration
                </li>
                <li>
                  Familiar with Apple's approval criteria and the processes to
                  deliver an maintain applications in the App Store
                </li>
              </ul>
            </div>
            <div className="jobDescription">
              <h5>Extra Points:</h5>
              <ul>
                <li>
                  For a Senior Technical Lead for client projects, we are also
                  specifically looking for a candidate with a Master's Degree or
                  PhD
                </li>
                <li>
                  Familiarity with Agile development practices, Scrum, iteration
                  planning, retrospect, and test driven development
                </li>
                <li>
                  Experience with MS ASP.NET MVC 4, Web API, Entity Framework
                </li>
                <li>Amazon EC2 an S3 configuration</li>
                <li>Database Development using SQL Server</li>
                <li>
                  Cross platform mobile development experience. i.E. basic
                  Android knowledge, PhoneGap, HTML 5
                </li>
                <li>
                  Mobile Web development experience. HTML 5, CSS3, jQuery,
                  jQuery Mobile
                </li>
                <li>Experience integrating electronic payment gateways</li>
                <li>Startup Experience</li>
              </ul>
            </div>
            <div>
              <a>
                <img src={require("../../assets/img/apply.png")} />
              </a>
            </div>
          </div>
        </div>
      );
    } else if (job === "androiddeveloper") {
      return (
        <div>
          <div id="androiddeveloper" className="modal-box">
            <h2>Android Developer</h2>
            <div className="jobDescription">
              Type: Full-Time/Part-Time
              <br />
              Location: Irvine, CA
              <br />
              Education: Bachelor's Degree or Master's Degree in Computer
              Science
              <br />
            </div>
            <div className="jobDescription">
              <h5>Responsibility:</h5>
              <ul>
                <li>
                  Develop state of the art Android applications with siginicant
                  client-server integration
                </li>
                <li>
                  Plenty of hands-on coding and optimization to meet esthetics
                  and business objective
                </li>
                <li>
                  Agile collaboration with designers, server development teams,
                  as well as iOS and Windows Phone 8 counterparts
                </li>
              </ul>
            </div>
            <div className="jobDescription">
              <h5>Requirements:</h5>
              <ul>
                <li>
                  Bachelor's or Master's degree in computer science or
                  equivalent
                </li>
                <li>
                  Familiar with all phases of the software development life
                  cycle and desire to apply this formally in a startup
                  environment
                </li>
                <li>
                  Detail oriented, passionate about software development, and a
                  great team spirit
                </li>
                <li>
                  Excellent communication skills and desire to work in a cross
                  functional team
                </li>
                <li>
                  Passion to implement breath-taking and efficient user
                  interfaces in collaboration with dedicated UI design team
                </li>
                <li>
                  Hands-on software development experience with object oriented
                  programming languages and design patterns
                </li>
                <li>
                  Experience with Java and preferably one significant
                  application delivered to the Google Play
                </li>
                <li>
                  Experience with REST/JSON based client-server communication,
                  Push Notification Services, and Social Media Integration
                </li>
                <li>
                  Familiar with Google's approval criteria and the processes to
                  deliver an maintain applications in the Google Play
                </li>
              </ul>
            </div>
            <div className="jobDescription">
              <h5>Extra Points:</h5>
              <ul>
                <li>
                  For a Senior Technical Lead for client projects, we are also
                  specifically looking for a candidate with a Master's Degree or
                  PhD
                </li>
                <li>
                  Familiarity with Agile development practices, Scrum, iteration
                  planning, retrospect, and test driven development
                </li>
                <li>
                  Experience with MS ASP.NET MVC 4, Web API, Entity Framework
                </li>
                <li>Amazon EC2 an S3 configuration</li>
                <li>Database Development using SQL Server</li>
                <li>
                  Cross platform mobile development experience. i.E. basic
                  Android knowledge, PhoneGap, HTML 5
                </li>
                <li>
                  Mobile Web development experience. HTML 5, CSS3, jQuery,
                  jQuery Mobile
                </li>
                <li>Experience integrating electronic payment gateways</li>
                <li>Startup Experience</li>
              </ul>
            </div>
            <div>
              <a>
                <img src={require("../../assets/img/apply.png")} />
              </a>
            </div>
          </div>
        </div>
      );
    } else if (job === "frontenddeveloper") {
      return (
        <div>
          <div id="frontenddeveloper" className="modal-box">
            <h2>Front-End Developer</h2>
            <div className="jobDescription">
              Type: Full-Time/Part-Time
              <br />
              Location: Irvine, CA
              <br />
              Education: Bachelor's Degree or Master's Degree in Computer
              Science
              <br />
            </div>
            <div className="jobDescription">
              <h5>Position:</h5>
              <ul>
                <li>
                  We have a high-end graphic design for a significant size
                  e-commerce web site and we have the REST-best web services to
                  provide the data and backend functionality
                </li>
                <li>
                  We also have highly capable MS.NET MVC4 developers who are
                  willing to share their knowledge and collaborate
                </li>
                <li>
                  We are looking for an HTML 5 enthusiast who can bring a
                  website to life. We need a developer who is detail oriented,
                  works well with a graphic design team, and has a passion for
                  HTML 5 animation
                </li>
              </ul>
            </div>
            <div className="jobDescription">
              <h5>Requirements:</h5>
              <ul>
                <li>
                  Develop and maintain an appealing start of the art e-commerce
                  site based on Microsoft ASP.NET MVC 4.0 with Web API Services
                </li>
                <li>Plenty of hands-on HTML5 and potentially C# coding</li>
                <li>Optimization to meet esthetics and business objective</li>
                <li>
                  Collaboration with Marketing and Sales on implementing
                  flexible campaigns for Web, Mobile, and Social Media
                </li>
                <li>
                  Agile collaboration with UX/Design, and mobile development
                  team (iOS, Android and Windows Phone 8) and backend
                  development team
                </li>
              </ul>
            </div>
            <div className="jobDescription">
              <h5>Extra Points:</h5>
              <ul>
                <li>
                  Detail oriented, passionate about software development, and a
                  great team spirit
                </li>
                <li>
                  Excellent communication skills and desire to work in a cross
                  functional team
                </li>
                <li>
                  Passion to implement appealing and efficient user interfaces
                  in collaboration with UI/UX design team
                </li>
                <li>
                  Experience with client Web Development in HTML 5, CSS3,
                  jQuery, jQuery Mobile
                </li>
                <li>
                  Experience with REST/JSON based client-server communication
                  and Social Media Integration
                </li>
              </ul>
            </div>
            <div>
              <a>
                <img src={require("../../assets/img/apply.png")} />
              </a>
            </div>
          </div>
        </div>
      );
    } else if (job === "mobiledevelopmentintern") {
      return (
        <div id="mobiledevelopmentintern" className="modal-box">
          <h2>Mobile Development Intern</h2>
          <div className="jobDescription">
            Type: Part-Time
            <br />
            Location: Irvine, CA
            <br />
            Education: Bachelor's Degree in Computer Science
            <br />
          </div>
          <div className="jobDescription">
            <h5>Responsibility:</h5>
            <ul>
              <li>
                Develop state of the art mobile applications with siginicant
                client-server integration
              </li>
              <li>
                Plenty of hands-on coding and optimization to meet esthetics and
                business objective
              </li>
              <li>
                Agile collaboration with designers, server development teams, as
                well as iOS, Android, or Windows Phone 8 counterparts
              </li>
            </ul>
          </div>
          <div className="jobDescription">
            <h5>Requirements:</h5>
            <ul>
              <li>
                Familiar with all phases of the software development life cycle
                and desire to apply this formally in a startup environment
              </li>
              <li>
                Detail oriented, passionate about software development, and a
                great team spirit
              </li>
              <li>
                Excellent communication skills and desire to work in a cross
                functional team
              </li>
              <li>
                Passion to implement breath-taking and efficient user interfaces
                in collaboration with dedicated UI design team
              </li>
              <li>
                Hands-on software development experience with object oriented
                programming languages and design patterns
              </li>
              <li>
                Experience with Objective-C, Java, or C# and preferably one
                significant application delivered to an App Store
              </li>
              <li>
                Experience with REST/JSON based client-server communication,
                Push Notification Services, and Social Media Integration
              </li>
            </ul>
          </div>
          <div className="jobDescription">
            <h5>Extra Points:</h5>
            <ul>
              <li>
                Pursuing a Bachelor's or Master's degree in computer science or
                equivalent
              </li>
              <li>
                Familiarity with Agile development practices, Scrum, iteration
                planning, retrospect, and test driven development
              </li>
              <li>
                Experience with MS ASP.NET MVC 4, Web API, Entity Framework
              </li>
              <li>Amazon EC2 an S3 configuration</li>
              <li>Database Development using SQL Server</li>
              <li>
                Cross platform mobile development experience. i.E. basic Android
                knowledge, PhoneGap, HTML 5
              </li>
              <li>
                Mobile Web development experience with HTML 5, CSS3, jQuery,
                jQuery Mobile
              </li>
              <li>Experience integrating electronic payment gateways</li>
              <li>Startup Experience</li>
            </ul>
          </div>
          <div>
            <a>
              <img src={require("../../assets/img/apply.png")} />
            </a>
          </div>
        </div>
      );
    } else if (job === "webdevelopmentintern") {
      return (
        <div id="webdevelopmentintern" className="modal-box">
          <h2>Web Development Intern</h2>
          <div className="jobDescription">
            Type: Part-Time
            <br />
            Location: Irvine, CA
            <br />
            Education: Bachelor's Degree in Computer Science
            <br />
          </div>
          <div className="jobDescription">
            <h5>Responsibility:</h5>
            <ul>
              <li>
                Develop state of the art mobile applications with siginicant
                client-server integration
              </li>
              <li>
                Plenty of hands-on coding and optimization to meet esthetics and
                business objective
              </li>
              <li>
                Agile collaboration with designers, server development teams, as
                well as iOS, Android, or Windows Phone 8 counterparts
              </li>
            </ul>
          </div>
          <div className="jobDescription">
            <h5>Requirements:</h5>
            <ul>
              <li>
                Familiar with all phases of the software development life cycle
                and desire to apply this formally in a startup environment
              </li>
              <li>
                Detail oriented, passionate about software development, and a
                great team spirit
              </li>
              <li>
                Excellent communication skills and desire to work in a cross
                functional team
              </li>
              <li>
                Passion to implement breath-taking and efficient user interfaces
                in collaboration with dedicated UI design team
              </li>
              <li>
                Hands-on software development experience with object oriented
                programming languages and design patterns
              </li>
              <li>
                Experience with HTML, CSS, or Javascript and preferably one
                significant web application present online
              </li>
              <li>
                Mobile Web development experience with HTML 5, CSS3, jQuery,
                jQuery Mobile
              </li>
              <li>
                Experience with MVC 4 and database/server communication
                processes
              </li>
            </ul>
          </div>
          <div className="jobDescription">
            <h5>Extra Points:</h5>
            <ul>
              <li>
                Pursuing a Bachelor's or Master's degree in computer science or
                equivalent
              </li>
              <li>
                Familiarity with Agile development practices, Scrum, iteration
                planning, retrospect, and test driven development
              </li>
              <li>
                Experience with MS ASP.NET MVC 4, Web API, Entity Framework
              </li>
              <li>Amazon EC2 an S3 configuration</li>
              <li>Database Development using SQL Server</li>
              <li>
                Cross platform mobile development experience. i.E. basic Android
                knowledge, PhoneGap, HTML 5
              </li>
              <li>Experience integrating electronic payment gateways</li>
              <li>Startup Experience</li>
            </ul>
          </div>
          <div>
            <a>
              <img src={require("../../assets/img/apply.png")} />
            </a>
          </div>
        </div>
      );
    } else if (job === "backenddeveloper") {
      return (
        <div>
          <div id="backenddeveloper" className="modal-box">
            <h2>Back-End Developer</h2>
            <div className="jobDescription">
              Type: Full-Time/Part-Time
              <br />
              Location: Irvine, CA
              <br />
              Education: Bachelor's Degree or Master's Degree in Computer
              Science
              <br />
            </div>
            <div className="jobDescription">
              <h5>Position:</h5>
              <ul>
                <li>
                  We have a high-end graphic design for a significant size
                  e-commerce web site and we have the REST-best web services to
                  provide the data and backend functionality
                </li>
                <li>
                  We also have highly capable MS.NET MVC4 developers who are
                  willing to share their knowledge and collaborate
                </li>
                <li>
                  We are looking for an ASP.net MVC4 enthusiast who can bring a
                  website to life. We need a developer who is detail oriented,
                  works well with a backend team, and has a passion for database
                  technology
                </li>
              </ul>
            </div>
            <div className="jobDescription">
              <h5>Requirements:</h5>
              <ul>
                <li>
                  Bachelor's or Master's degree in computer science or
                  equivalent
                </li>
                <li>
                  Develop and maintain an appealing start of the art e-commerce
                  site based on Microsoft ASP.NET MVC 4.0 with Web API Services
                </li>
                <li>
                  Plenty of hands-on database languages and potentially C#
                  coding
                </li>
                <li>Optimization to meet esthetics and business objective</li>
                <li>
                  Collaboration with Marketing and Sales on implementing
                  flexible campaigns for Web, Mobile, and Social Media
                </li>
                <li>
                  Agile collaboration with UX/Design, and mobile development
                  team (iOS, Android and Windows Phone 8) and frontend
                  development team
                </li>
              </ul>
            </div>
            <div className="jobDescription">
              <h5>Extra Points:</h5>
              <ul>
                <li>
                  For a Senior Technical Lead for client projects, we are also
                  specifically looking for a candidate with a Master's Degree or
                  PhD
                </li>
                <li>
                  Detail oriented, passionate about software development, and a
                  great team spirit
                </li>
                <li>
                  Excellent communication skills and desire to work in a cross
                  functional team
                </li>
                <li>
                  Passion to implement appealing and efficient data calls in
                  collaboration with UI/UX design team
                </li>
                <li>Experience with ASP.net, SQL, JQuery, and AJAX</li>
                <li>
                  Experience with REST/JSON based client-server communication
                  and Social Media Integration
                </li>
                <li>
                  Experience with MS ASP.NET MVC 4, Web API, Entity Framework
                </li>
                <li>Amazon EC2 an S3 configuration</li>
                <li>Database development with SQL server SQL</li>
                <li>Startup Experience</li>
              </ul>
            </div>
            <div>
              <a>
                <img src={require("../../assets/img/apply.png")} />
              </a>
            </div>
          </div>
        </div>
      );
    } else {
      return <div>position filled</div>;
    }
  }
}
